import { render } from "./Login.vue?vue&type=template&id=70e005fd&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=70e005fd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-70e005fd"

export default script